<h6 class="muted hidden-on-collapsed">
    <ng-content></ng-content>
</h6>
